/* eslint-disable no-shadow */
export enum FieldLength {
    campaignTitle = 150,
    advertiserName = 80,
}